import { DomainError } from '@nizza/core';

export class AccountNotSetError extends DomainError {
  constructor() {
    super(
      'ACCOUNT_NOT_SET',
      'Account has not been set for the CollectionService.',
    );
  }
}

export class CollectionOperationError extends DomainError {
  constructor(operation: string, originalMessage?: string, details?: unknown) {
    const message = `Failed to ${operation} collection${
      originalMessage ? ': ' + originalMessage : '.'
    }`;
    super('COLLECTION_OPERATION_ERROR', message, details);
  }
}

export class CollectionNotFoundError extends CollectionOperationError {
  constructor(id: string) {
    super('find', `Collection with ID '${id}' not found.`);
    this.name = 'CollectionNotFoundError';
  }
}

export class CollectionCreationError extends CollectionOperationError {
  constructor(originalMessage?: string, details?: unknown) {
    super('create', originalMessage, details);
    this.name = 'CollectionCreationError';
  }
}

export class CollectionUpdateError extends CollectionOperationError {
  constructor(id: string, originalMessage?: string, details?: unknown) {
    super(
      'update',
      originalMessage ? `for ID '${id}': ${originalMessage}` : `for ID '${id}'`,
      details,
    );
    this.name = 'CollectionUpdateError';
  }
}

export class CollectionDeletionError extends CollectionOperationError {
  constructor(id: string, originalMessage?: string, details?: unknown) {
    super(
      'delete',
      originalMessage ? `for ID '${id}': ${originalMessage}` : `for ID '${id}'`,
      details,
    );
    this.name = 'CollectionDeletionError';
  }
}

export class CollectionSyncError extends CollectionOperationError {
  constructor(
    collectionId: string,
    originalMessage?: string,
    details?: unknown,
  ) {
    super(
      'sync products for',
      originalMessage
        ? `collection '${collectionId}': ${originalMessage}`
        : `collection '${collectionId}'`,
      details,
    );
    this.name = 'CollectionSyncError';
  }
}
